import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';
import { ProductUUID } from '../../../productsTypes';

import {
  FETCH_PRODUCT_DOWNLOAD_URLS_QUERY,
  FetchProductDownloadUrlsQueryResponse
} from '../../../queries/fetchProductDownloadUrls.query';

import { useShowProduct } from '../../../hooks/useShowProduct';
import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { DownloadUrlsModalButton } from '../../../../common/components/modalButtons/DownloadUrlsModalButton';

import { ProductCache } from '../../../ProductCache';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadProductSeparatelyButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  productUuid: ProductUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadProductSeparatelyButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  productUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadProductSeparatelyButtonProps & GADataType) {
  const { productLoading, refetchProduct, productError } =
    useShowProduct<FetchProductDownloadUrlsQueryResponse>({
      cacheKey: ProductCache.downloadUrls(productUuid),
      options: {
        enabled: false,
        enabledPlaceholder: false
      },
      query: FETCH_PRODUCT_DOWNLOAD_URLS_QUERY,
      uuid: productUuid
    });

  useShowToastOnErrorChange({ error: productError });

  return (
    <DownloadUrlsModalButton<'product'>
      className={className}
      dataGa={dataGa}
      disabled={productLoading}
      downloadUrlsScope="downloadUrls"
      i18nText={i18nText}
      icon={icon}
      iconClassName={iconClassName}
      refetchItemDownloadUrls={refetchProduct}
      scope="product"
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
    />
  );
}

export default DownloadProductSeparatelyButton;
